var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehiclesDelayedForStationComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2599 19.4001C38.4057 20.0273 38.8261 21.4647 38.1989 22.6105L32.8989 32.2928C32.2717 33.4386 30.8343 33.8591 29.6884 33.2318L20.6978 28.3104C19.9339 27.8922 19.6536 26.934 20.0717 26.1701L26.1289 15.1047C26.547 14.3407 27.5053 14.0605 28.2692 14.4786L37.2599 19.4001Z",
    fill: "#E7332F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1323 22.928C37.5142 23.1371 37.6544 23.6162 37.4453 23.9982L33.6596 30.9141C33.4505 31.296 32.9714 31.4362 32.5894 31.2271C32.2075 31.018 32.0673 30.5389 32.2764 30.1569L36.0621 23.241C36.2712 22.8591 36.7503 22.7189 37.1323 22.928Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1745 33.1526C31.3273 33.2362 31.519 33.1802 31.6026 33.0274L32.0569 32.1975C32.1405 32.0447 32.0845 31.8531 31.9317 31.7694L31.1018 31.3151C30.949 31.2315 30.7573 31.2876 30.6737 31.4404L30.2194 32.2703C30.1358 32.423 30.1918 32.6147 30.3446 32.6983L31.1745 33.1526Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2321 22.0867C37.3849 22.1703 37.5766 22.1143 37.6602 21.9615L38.1145 21.1316C38.1981 20.9788 38.1421 20.7871 37.9893 20.7035L37.1594 20.2492C37.0066 20.1656 36.815 20.2217 36.7313 20.3744L36.277 21.2043C36.1934 21.3571 36.2495 21.5488 36.4022 21.6324L37.2321 22.0867Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2892 20.2779C33.0531 20.6961 33.3333 21.6543 32.9152 22.4182L29.8866 27.9509C29.4685 28.7148 28.5102 28.9951 27.7463 28.577L25.6715 27.4413C24.9076 27.0231 24.6273 26.0648 25.0455 25.3009L28.0741 19.7682C28.4922 19.0043 29.4505 18.724 30.2144 19.1422L32.2892 20.2779Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5057 12.9669C26.2696 13.3851 26.5499 14.3433 26.1317 15.1072L20.0746 26.1727C19.6564 26.9366 18.6982 27.2168 17.9343 26.7987L9.6352 22.2558C8.10738 21.4195 7.54681 19.503 8.38313 17.9752L12.926 9.67611C13.7623 8.1483 15.6788 7.58773 17.2066 8.42405L25.5057 12.9669Z",
    fill: "white",
    stroke: "#9F9F9F",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesDelayedForStationComponent);
export default __webpack_public_path__ + "static/media/vehiclesDelayedForStationComponent.9b1190807fdb13b0d468b4a129211e3a.svg";
export { ForwardRef as ReactComponent };